import React from 'react';
import Appearance from 'styles/Appearance.js';
import Button from 'views/Button.js';
import Utils from 'files/Utils.js';

// Restrained, product-led hero: title → headline → copy + Shop Now → image, on
// every screen size. Copy and CTA come before the image so Shop Now lands on a
// phone's first screen.
const Hero = ({ onShopNow, onOpenQuiz, featuredProduct }) => {

    const mobile = Utils.isMobile();

    const eyebrow = (
        <span key={'eyebrow'} style={{
            ...Appearance.textStyles.label({ color: Appearance.colors.primary() }),
            display: 'block',
            marginBottom: 16,
        }}>
            {'Aqua Link Connect'}
        </span>
    );

    const heading = (
        <h1 key={'heading'} style={{
            // 64px on desktop so each sentence fits on its own line in the hero
            ...Appearance.textStyles.heroHeading(mobile ? {} : { fontSize: 64 }),
            margin: '0 auto 22px',
            textWrap: 'balance',
        }}>
            {/* One sentence per line */}
            <span style={{ display: 'block' }}>{'Catch Leaks Early.'}</span>
            <span style={{ display: 'block' }}>{'Avoid Costly Water Damage.'}</span>
        </h1>
    );

    const image = (
        <div key={'image'} style={{
            marginTop: mobile ? 32 : 64,
            marginBottom: mobile ? 0 : 64,
            borderRadius: 28,
            backgroundColor: Appearance.colors.offWhite,
            // Phones: the photo's own shape, so the sensors and hub at its edges aren't cropped
            ...(mobile ? { aspectRatio: '1984 / 1179' } : { height: 520 }),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
        }}>
            <img
                src={'/images/starter-pack-white-cropped.jpg'}
                alt={'Water Sensor'}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
    );

    const body = (
        <div key={'body'}>
            <p style={{
                ...Appearance.textStyles.body({ fontSize: mobile ? 17 : 21, lineHeight: 1.45 }),
                maxWidth: '38ch',
                margin: '0 auto',
            }}>
                {'An alarm sounds at the leak, alerts reach up to 8 people by app, text and email, and an optional bedside unit wakes you at night. Miss your phone, and you still won’t miss the leak. No monthly fees.'}
            </p>

            {/* Actions — Shop Now leads (to pricing); the quiz is the secondary path */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 26,
                marginTop: 30,
                flexWrap: 'wrap',
            }}>
                <Button label={'Shop Now'} type={'primary'} onClick={onShopNow} />
                <span
                    onClick={onOpenQuiz || onShopNow}
                    style={{
                        color: Appearance.colors.primary(),
                        fontFamily: Appearance.fonts.body,
                        fontSize: 17,
                        fontWeight: 500,
                        cursor: 'pointer',
                    }}>
                    {'Find Your Solution\u00A0›'}
                </span>
            </div>

            {/* Quiet trust line */}
            <div style={{
                display: 'flex',
                flexDirection: mobile ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: 'center',
                gap: mobile ? 8 : 10,
                marginTop: 24,
            }}>
                <div style={{ display: 'flex', gap: 2 }}>
                    {[...Array(5)].map((_, index) => (
                        <i key={index} className={'fas fa-star'} style={{ fontSize: 12, color: Appearance.colors.primary() }} />
                    ))}
                </div>
                <span style={Appearance.textStyles.caption({ color: Appearance.colors.subText() })}>
                    {'Rated 4.6 / 5 across 73,000+ protected homes'}
                </span>
            </div>
        </div>
    );

    const children = [eyebrow, heading, body, image];

    return (
        <section id={'hero'} style={{
            width: '100%',
            backgroundColor: Appearance.colors.white,
            paddingTop: `calc(${mobile ? 92 : 84}px + var(--offer-banner-height, 0px))`,
        }}>
            <div style={{
                maxWidth: 980,
                margin: '0 auto',
                padding: mobile ? '20px 20px 44px' : '72px 40px 0',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
            }}>
                {children}
            </div>
        </section>
    );
};

export default Hero;
